var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrafting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.93,10.22v17.64c0,1.08-0.88,1.96-1.96,1.96H3.56c-0.85,0-1.62-0.34-2.17-0.9 c-0.56-0.56-0.9-1.32-0.9-2.17V8.25h25.48C27.06,8.25,27.93,9.13,27.93,10.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.97,30.31H3.56c-0.96,0-1.85-0.37-2.52-1.05C0.37,28.59,0,27.69,0,26.75V8.25c0-0.27,0.22-0.49,0.49-0.49 h25.48c1.35,0,2.45,1.1,2.45,2.45v17.64C28.42,29.21,27.32,30.31,25.97,30.31z M0.98,8.74v18c0,0.68,0.27,1.33,0.76,1.82 c0.48,0.49,1.13,0.76,1.82,0.76h22.41c0.81,0,1.47-0.66,1.47-1.47V10.22c0-0.81-0.66-1.47-1.47-1.47H0.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.37,6.59v20.29c0-1.71-1.31-3.08-2.94-3.08c-1.62,0-2.94,1.37-2.94,3.08H0.49V6.59 c0-1.7,1.32-3.07,2.94-3.07C5.06,3.52,6.37,4.89,6.37,6.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.37,27.37c-0.27,0-0.49-0.22-0.49-0.49c0-1.43-1.1-2.59-2.45-2.59s-2.45,1.16-2.45,2.59 c0,0.27-0.22,0.49-0.49,0.49S0,27.15,0,26.88V6.59c0-1.96,1.54-3.56,3.44-3.56c1.89,0,3.43,1.6,3.43,3.56v20.29 C6.86,27.15,6.64,27.37,6.37,27.37z M3.44,4.01c-1.35,0-2.46,1.16-2.46,2.58v17.8c0.62-0.67,1.49-1.08,2.46-1.08 c0.96,0,1.82,0.41,2.45,1.07V6.59C5.88,5.17,4.78,4.01,3.44,4.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.31,
    y: 10.7,
    className: "st1",
    width: 16.66,
    height: 16.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.97,27.86H9.31c-0.27,0-0.49-0.22-0.49-0.49V10.7c0-0.27,0.22-0.49,0.49-0.49h16.66 c0.27,0,0.49,0.22,0.49,0.49v16.66C26.46,27.64,26.24,27.86,25.97,27.86z M9.8,26.88h15.68V11.19H9.8V26.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.91,18.06H9.8v-0.98h4.11C14.68,17.07,14.68,18.06,13.91,18.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.62,17.07l-1.03,0.98h-2.04c-0.84,0-0.84-0.98,0-0.98H21.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "14.7,24.91 14.7,26.88 13.72,26.88 13.72,24.92  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.09,16.06c0,0.27-0.22,0.49-0.49,0.04h-0.92v-3.92h0.98V16C16.91,15.59,17.09,15.81,17.09,16.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,20.02h2.8c0.66,0,0.66,0.98,0,0.98H9.8V20.02z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.33,22.75l-1.9-0.59L28.4,11.14V9.85L15.57,20.71l-1.43,1.31c-0.13,0.12-0.19,0.3-0.15,0.47 c0.04,0.17,0.17,0.31,0.33,0.36l2.37,0.73l-0.02,6.74h0.98l0.02-7.1C17.68,23,17.54,22.81,17.33,22.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "39.7,13.15 39.7,10.21 43.62,10.21 43.62,17.07  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.62,17.56c-0.27,0-0.49-0.22-0.49-0.49V10.7h-2.94v2.45c0,0.27-0.22,0.49-0.49,0.49 c-0.27,0-0.49-0.22-0.49-0.49v-2.94c0-0.27,0.22-0.49,0.49-0.49h3.92c0.27,0,0.49,0.22,0.49,0.49v6.86 C44.11,17.35,43.89,17.56,43.62,17.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38.72,
    y: 8.25,
    className: "st1",
    width: 5.88,
    height: 1.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.6,10.7h-5.88c-0.27,0-0.49-0.22-0.49-0.49V8.25c0-0.27,0.22-0.49,0.49-0.49h5.88 c0.27,0,0.49,0.22,0.49,0.49v1.96C45.09,10.48,44.87,10.7,44.6,10.7z M39.21,9.72h4.9V8.74h-4.9V9.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.35,21.98 33.01,7.32 49.51,21.98  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.51,22.47H16.35c-0.2,0-0.39-0.13-0.46-0.32c-0.07-0.19-0.02-0.41,0.13-0.54L32.69,6.95 c0.18-0.16,0.46-0.16,0.65,0l16.5,14.66c0.15,0.13,0.2,0.35,0.13,0.54C49.9,22.34,49.71,22.47,49.51,22.47z M17.65,21.49h30.57 L33.01,7.97L17.65,21.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.77,16.25c0,1.52-1.23,2.76-2.76,2.76c-1.52,0-2.76-1.23-2.76-2.76s1.24-2.76,2.76-2.76 C34.54,13.49,35.77,14.73,35.77,16.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.01,19.5c-1.79,0-3.24-1.46-3.24-3.25c0-1.79,1.46-3.25,3.24-3.25c1.79,0,3.25,1.46,3.25,3.25 C36.26,18.04,34.8,19.5,33.01,19.5z M33.01,13.98c-1.25,0-2.26,1.02-2.26,2.27s1.02,2.27,2.26,2.27c1.25,0,2.27-1.02,2.27-2.27 S34.26,13.98,33.01,13.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.13,
    y: 21.98,
    className: "st0",
    width: 29.4,
    height: 22.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.54,45.01h-29.4c-0.27,0-0.49-0.22-0.49-0.49V21.98c0-0.27,0.22-0.49,0.49-0.49h29.4 c0.27,0,0.49,0.22,0.49,0.49v22.54C48.03,44.79,47.81,45.01,47.54,45.01z M18.62,44.03h28.42V22.47H18.62V44.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.91,
    y: 34.72,
    className: "st1",
    width: 6.86,
    height: 9.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.77,45.01h-6.86c-0.27,0-0.49-0.22-0.49-0.49v-9.8c0-0.27,0.22-0.49,0.49-0.49h6.86 c0.27,0,0.49,0.22,0.49,0.49v9.8C36.26,44.79,36.05,45.01,35.77,45.01z M29.4,44.03h5.88v-8.82H29.4V44.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.6,38.15h-4.9c-0.27,0-0.49-0.22-0.49-0.49c0-0.27,0.22-0.49,0.49-0.49h4.9c0.27,0,0.49,0.22,0.49,0.49 C45.09,37.93,44.87,38.15,44.6,38.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.7,
    y: 34.72,
    className: "st1",
    width: 4.9,
    height: 6.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.6,42.07h-4.9c-0.27,0-0.49-0.22-0.49-0.49v-6.86c0-0.27,0.22-0.49,0.49-0.49h4.9 c0.27,0,0.49,0.22,0.49,0.49v6.86C45.09,41.85,44.87,42.07,44.6,42.07z M40.19,41.09h3.92v-5.88h-3.92V41.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.97,38.15h-4.9c-0.27,0-0.49-0.22-0.49-0.49c0-0.27,0.22-0.49,0.49-0.49h4.9c0.27,0,0.49,0.22,0.49,0.49 C26.46,37.93,26.24,38.15,25.97,38.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.07,
    y: 34.72,
    className: "st1",
    width: 4.9,
    height: 6.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.97,42.07h-4.9c-0.27,0-0.49-0.22-0.49-0.49v-6.86c0-0.27,0.22-0.49,0.49-0.49h4.9 c0.27,0,0.49,0.22,0.49,0.49v6.86C26.46,41.85,26.24,42.07,25.97,42.07z M21.56,41.09h3.92v-5.88h-3.92V41.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.6,29.33h-4.9c-0.27,0-0.49-0.22-0.49-0.49c0-0.27,0.22-0.49,0.49-0.49h4.9c0.27,0,0.49,0.22,0.49,0.49 C45.09,29.11,44.87,29.33,44.6,29.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.7,
    y: 24.92,
    className: "st1",
    width: 4.9,
    height: 6.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.6,32.27h-4.9c-0.27,0-0.49-0.22-0.49-0.49v-6.86c0-0.27,0.22-0.49,0.49-0.49h4.9 c0.27,0,0.49,0.22,0.49,0.49v6.86C45.09,32.05,44.87,32.27,44.6,32.27z M40.19,31.29h3.92v-5.88h-3.92V31.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.79,29.33h-3.92c-0.27,0-0.49-0.22-0.49-0.49c0-0.27,0.22-0.49,0.49-0.49h3.92 c0.27,0,0.49,0.22,0.49,0.49C35.28,29.11,35.07,29.33,34.79,29.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.89,
    y: 24.92,
    className: "st1",
    width: 4.9,
    height: 6.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.79,32.27h-4.9c-0.27,0-0.49-0.22-0.49-0.49v-6.86c0-0.27,0.22-0.49,0.49-0.49h4.9 c0.27,0,0.49,0.22,0.49,0.49v6.86C35.28,32.05,35.07,32.27,34.79,32.27z M30.38,31.29h3.92v-5.88h-3.92V31.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.07,
    y: 24.92,
    className: "st1",
    width: 4.9,
    height: 6.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.97,32.27h-4.9c-0.27,0-0.49-0.22-0.49-0.49v-6.86c0-0.27,0.22-0.49,0.49-0.49h4.9 c0.27,0,0.49,0.22,0.49,0.49v6.86C26.46,32.05,26.24,32.27,25.97,32.27z M21.56,31.29h3.92v-5.88h-3.92V31.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5,44.99v0.51c-0.02,0.54-0.46,0.98-0.99,0.98H17.15c-0.54,0-0.98-0.44-0.98-0.98v-0.51 c0.01-0.54,0.44-0.98,0.98-1.45h30.47c0.7,0,1.4,0.33,1.73,0.94C49.44,44.64,49.49,44.81,49.5,44.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.51,46.97H17.15c-0.81,0-1.47-0.66-1.47-1.47v-0.51c0.01-0.76,0.57-1.32,1.14-1.82 c0.09-0.08,0.2-0.12,0.32-0.12h30.47c0.94,0,1.76,0.46,2.16,1.2c0.13,0.24,0.2,0.48,0.21,0.73c0,0.01,0,0.01,0,0.02v0.51 C49.95,46.33,49.3,46.97,48.51,46.97z M17.34,44.03c-0.43,0.39-0.67,0.68-0.68,0.97v0.5c0,0.27,0.22,0.49,0.49,0.49h31.36 c0.27,0,0.49-0.23,0.5-0.51V45c0-0.09-0.03-0.19-0.09-0.29c-0.22-0.41-0.73-0.68-1.3-0.68H17.34z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafting);
export default __webpack_public_path__ + "static/media/drafting.14f240e556937fd101298b18f5e557f8.svg";
export { ForwardRef as ReactComponent };